<template>
	<div id="bootom">
		<div class="w">
			<ol class="slogen">
				<li class="item">
					<img src="../assets/img/footer/1.png" alt="">
					<div>
						<p style="font-size: 16px;color: #333;">资源保证</p>
						<p style="font-size: 12px;color: #999999;">优质可靠的资源保证</p>
					</div>
				</li>
				<li class="item">
					<img src="../assets/img/footer/2.png" alt="">
					<div>
						<p style="font-size: 16px;color: #333;">交易保障</p>
						<p style="font-size: 12px;color: #999999;">全方位的安全保证</p>
					</div>
				</li>
				<li class="item">
					<img src="../assets/img/footer/3.png" alt="">
					<div>
						<p style="font-size: 16px;color: #333;">公开透明</p>
						<p style="font-size: 12px;color: #999999;">标准流程 公平公正</p>
					</div>
				</li>
				<li class="item">
					<img src="../assets/img/footer/4.png" alt="">
					<div>
						<p style="font-size: 16px;color: #333;">精准匹配</p>
						<p style="font-size: 12px;color: #999999;">海量资源多种类目</p>
					</div>
				</li>
			</ol>
		</div>
		<div class="xian"></div>
		<div class="w" style="height: 286px;display: flex;align-items: center;justify-content: center;">
			<div class="wrap">
				<dl>
					<dt >快速导航</dt>
					<dd @click="nav('/corpore')">竞价处置</dd>
					<dd @click="nav('/pricing')">金属行情</dd>
					<dd @click="nav('/cooperation')">合作服务</dd>
					<dd @click="goAbout">关于我们</dd>
				</dl>
				<dl>
					<dt>帮助中心</dt>
					<dd @click="nav('/help',29)">竞拍流程</dd>
					<dd @click="nav('/help',6)">出价规则</dd>
					<dd @click="nav('/help',7)">成交规则</dd>
					<dd @click="nav('/help',8)">保证金规则</dd>
				</dl>
				<dl>
					<dt></dt>
					<dd @click="nav('/help',30)" style="margin-top: 45px;">注册认证</dd>
					<dd @click="nav('/help',31)">拍前准备</dd>
					<dd @click="nav('/help',32)">缴纳金保证</dd>
					<dd @click="nav('/help',33)">出价竞拍</dd>
				</dl>
				<div class="br"></div>
				<dl>
					<dt>联系我们</dt>
					<dd>
						<span>客服热线：</span>
						<span>400-801-3201</span>
					</dd>
					<dd>
						<span>邮箱：</span>
						<span>cpt_hebei@163.com</span>
					</dd>
					<dd>
						<span>地址：</span>
						<span>河北省石家庄市长安区建华北大街 28 号中恒大厦北塔 2506 室</span>
					</dd>
				</dl>
				<div class="ma">
					<div>
						<img src="../assets/img/footer/app.png" alt="">
						<p>拆拍通 APP</p>
					</div>
					<div>
						<img src="../assets/img/footer/gongzhonghao.jpg" alt="">
						<p>官方微信账号</p>
					</div>
				</div>
			</div>
		</div>

		<div class="footer">
			<div class="footer-line company">拆拍通（河北）拍卖有限公司</div>
			<div class="footer-line">
				<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">冀 ICP 备 2026004509 号 -1</a>
				<span class="footer-divider">|</span>
				<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010202004509" target="_blank" rel="noopener noreferrer">冀公网安备 13010202004509 号</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {

		}
	},
	methods:{
		nav(value,index){
      if (index) {
        this.$router.push({
          path:value,
          query:{
            id:index
          }
        })
      }else{
        this.$router.push(value)
      }

		},
		goAbout() {
			window.open('https://rudaweiye.chaipaitong.com/', '_blank');
		}
	}
}
</script>

<style scoped lang="scss">
	#bootom {
		min-width: 1500px;
		background-color: #F5F5F5;
		overflow: hidden;

		.xian {
			width: 100%;
			height: 1px;
			background-color: #E5E5E5;
		}

		.w {
			width: 1400px;
			margin: 0 auto;

			.slogen {
				width: 1276px;
				height: 48px;

				margin: 30px auto;
				display: flex;
				justify-content: space-between;

				.item {
					width: 198px;
					height: 48px;
					display: flex;
					justify-content: space-around;
					align-items: center;

					img {
						width: 48px;
						height: 48px;
					}
				}
			}

			.wrap {
				width: 1400px;
				height: 186px;
				display: flex;

				justify-content: space-between;

				.br {
					width: 1px;
					height: 180px;
					background-color: #E5E5E5;
				}

				.ma {
					width: 280px;
					height: 160px;
					display: flex;
					justify-content: space-between;

					div {
						width: 120px;
						height: 160px;
						img{
							width: 120px;
							height: 120px;
						}
						p{
							font-size: 14px;
							color: #666666;
							text-align: center;
							margin-top: 10px;
						}
					}
				}

				dl {
					padding-right: 50px;

					dt {
						font-size: 16px;
						color: #666666;
						margin-bottom: 24px;
					}

					dd{
						font-size: 14px;
						color: #AAAAAA;
						margin-bottom: 18px;
            cursor: pointer;
					}
				}
			}

		}





		.footer {
			width: 100%;
			height: 87px;
			background-color: #333333;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 14px;

			.footer-line {
				line-height: 1.8;

				&.company {
					font-size: 13px;
					opacity: 0.75;
				}

				a {
					color: #cccccc;
					text-decoration: none;
					transition: color 0.25s ease;

					&:hover {
						color: #ffffff;
						text-decoration: underline;
					}
				}

				.footer-divider {
					margin: 0 12px;
					opacity: 0.4;
				}
			}

			img{
				width: 20px;
				height: 20px;
			}
		}

	}
</style>
